/* eslint-disable */
(function (global, undefined) {

	var Terminal = Terminal || function(containerID, options) {
		if (!containerID) return;

		var defaults = {
			welcome: '',
			prompt: '',
			separator: '&gt;',
			theme: 'interlaced',
			maxRow: 500
		};

		var options = options || defaults;
		options.welcome = options.welcome || defaults.welcome;
		options.prompt = options.prompt || defaults.prompt;
		options.separator = options.separator || defaults.separator;
		options.theme = options.theme || defaults.theme;
		options.maxRow = options.maxRow || defaults.maxRow;

		var extensions = Array.prototype.slice.call(arguments, 2);

		var _history = localStorage.history ? JSON.parse(localStorage.history) : [];
		var _histpos = _history.length;
		var _histtemp = '';

		// Create terminal and cache DOM nodes;
		var _terminal = containerID instanceof HTMLElement ? containerID : document.getElementById(containerID);
		_terminal.classList.add('terminal');
		_terminal.classList.add('terminal-' + options.theme);
		_terminal.insertAdjacentHTML('beforeEnd', [
			'<div class="background"><div class="interlace"></div></div>',
			'<div class="container">',
			'<output></output>',
			'<table class="input-line">',
			'<tr><td nowrap><div class="prompt">' + options.prompt + options.separator + '</div></td><td width="100%" style="word-break: break-all"><input class="cmdline" spellcheck="false" autofocus /></td></tr>',
			'</table>',
			'</div>'].join(''));
		var _container = _terminal.querySelector('.container');
		var _inputLine = _container.querySelector('.input-line');
		var _cmdLine = _container.querySelector('.input-line .cmdline');
		var _output = _container.querySelector('output');
		var _prompt = _container.querySelector('.prompt');
		var _background = document.querySelector('.background');

		// Hackery to resize the interlace background image as the container grows.
		_output.addEventListener('DOMSubtreeModified', function(e) {
			// Works best with the scroll into view wrapped in a setTimeout.
			setTimeout(function() {
				_cmdLine.scrollIntoViewIfNeeded();
			}, 0);
			e.stopPropagation();
		}, false);

		if (options.welcome) {
			output(options.welcome);
		}

		_terminal.addEventListener('click', function(e) {
			_cmdLine.focus();
			e.stopPropagation();
		}, false);

		_output.addEventListener('click', function(e) {
			e.stopPropagation();
		}, false);

		// Always force text cursor to end of input line.
		_cmdLine.addEventListener('click', inputTextClick, false);
		_inputLine.addEventListener('click', function(e) {
			_cmdLine.focus();
		}, false);

		// Handle up/down key presses for shell history and enter for new command.
		_cmdLine.addEventListener('keyup', historyHandler, false);
		_cmdLine.addEventListener('keydown', processNewCommand, false);
		_cmdLine.addEventListener('focus', function() {
			setTimeout(function() {
				_cmdLine.scrollIntoViewIfNeeded();
			}, 200);
		}, false);

		// fix: ios12微信浏览器失去焦点后页面不会自动恢复
		_cmdLine.addEventListener('blur',function() {
			setTimeout(function(){
				window.scrollTo(0, 0);
			},100)
		});

		// document.body.addEventListener('focus', function (e) {
		// 	console.log('document.body');
    //   setTimeout(() => {
		// 		_cmdLine.scrollIntoViewIfNeeded();
		// 	}, 100);
    // }, true);

		window.addEventListener('keyup', function(e) {
			_cmdLine.focus();
			e.stopPropagation();
			e.preventDefault();
		}, false);

		function inputTextClick(e) {
			this.value = this.value;
			setTimeout(() => {
				_cmdLine.scrollIntoViewIfNeeded();
			}, 200);
			e.stopPropagation();
		}

		function historyHandler(e) {
			// Clear command-line on Escape key.
			if (e.keyCode == 27) {
				this.value = '';
				e.stopPropagation();
				e.preventDefault();
			}

			if (_history.length && (e.keyCode == 38 || e.keyCode == 40)) {
				if (_history[_histpos]) {
					_history[_histpos] = this.value;
				}
				else {
					_histtemp = this.value;
				}

				if (e.keyCode == 38) {
					// Up arrow key.
					_histpos--;
					if (_histpos < 0) {
						_histpos = 0;
					}
				}
				else if (e.keyCode == 40) {
					// Down arrow key.
					_histpos++;
					if (_histpos > _history.length) {
						_histpos = _history.length;
					}
				}

				this.value = _history[_histpos] ? _history[_histpos] : _histtemp;

				// Move cursor to end of input.
				this.value = this.value;
			}
		}

		function processNewCommand(e) {
			// Only handle the Enter key.
			if (e.keyCode != 13) return;
			_cmdLine.blur();
			var cmdline = this.value;

			execute(cmdline);
		}

		function execute(cmdline, custom) {
			_cmdLine.value = cmdline;
			// Save shell history.
			if (cmdline) {
				_history[_history.length] = cmdline;
				localStorage['history'] = JSON.stringify(_history);
				_histpos = _history.length;
			}

			// Duplicate current input and append to output section.
			var line = _cmdLine.parentNode.parentNode.parentNode.parentNode.cloneNode(true);
			line.removeAttribute('id');
			line.classList.add('line');
			var input = line.querySelector('input.cmdline');
			input.autofocus = false;
			input.readOnly = true;
			input.insertAdjacentHTML('beforebegin', input.value);
			input.parentNode.removeChild(input);
			_output.appendChild(line);

			// Hide command line until we're done processing input.
			_inputLine.classList.add('hidden');

			// Clear/setup line for next input.
			_cmdLine.value = '';

			// Parse out command, args, and trim off whitespace.
			if (cmdline && cmdline.trim()) {
				var args = cmdline.split(' ').filter(function(val, i) {
					return val;
				});
				var cmd = args[0];
				args = args.splice(1); // Remove cmd from arg list.
			}

			var directSkip = true; // 是否直接显示输入（是否等待执行）

			if (cmd) {
				var response = 'pending';
				for (var index in extensions) {
					var ext = extensions[index];
					if (ext.execute && !custom) response = ext.execute(cmd, args);
					if (response !== false) break;
				}
				
				startLoading();

				if (response === false) {
					stopLoading();
					response = cmd + ': command not found';
				} else if (response instanceof Promise) {
					directSkip = false;
					response.then(function(data) {
						stopLoading();
						_inputLine.classList.remove('hidden');
						output(data);
					}).catch(function(err) {
						stopLoading();
						_inputLine.classList.remove('hidden');
						output('<div style="color: red;">'+err+'</div>');
					});
				} else if (response === 'pending') {
					directSkip = false;
				} else {
					stopLoading();
					output(response);
				}
			}

			// Show the command line.
			directSkip && _inputLine.classList.remove('hidden');
		}

		function clear() {
			_output.innerHTML = '';
			_cmdLine.value = '';
			_background.style.minHeight = '';
		}

		function output(html) {
			var loadingDom = document.getElementById('js-command-loading');
			if (loadingDom) {
				loadingDom.insertAdjacentHTML('beforebegin', html);
			} else {
				_output.insertAdjacentHTML('beforeEnd', html);
			}

			maxRowListener();
			
			_cmdLine.scrollIntoViewIfNeeded();
			// _terminal.parentNode.scrollTop = _terminal.parentNode.Height;
		}

		function startLoading() {
			_output.insertAdjacentHTML('beforeEnd', '<div class="loading-container" id="js-command-loading"></div>');
		}

		function stopLoading() {
			var loadingDom = document.getElementById('js-command-loading');
			if (loadingDom) {
				loadingDom.parentNode.removeChild(loadingDom);
			}
		}

		function endExecute(result) {
			stopLoading();
			_inputLine.classList.remove('hidden');
			output(result);
		}

		function disableCmdline() {
			_cmdLine.setAttribute('disabled', 'disabled');
		}

		function ableCmdline() {
			_cmdLine.removeAttribute('disabled');
		}

		function maxRowListener() {
			var outputEl = document.querySelector('output');
			var allChildEl = outputEl.childNodes;
			if (allChildEl.length > options.maxRow) {
				var exceed = allChildEl.length - options.maxRow;
				for (var index = 0; index < exceed; index++) {
					var element = allChildEl[index];
					outputEl.removeChild(element);
				}
			}
		}

		return {
			clear: clear,
			disableCmdline: disableCmdline,
			ableCmdline: ableCmdline,
			setPrompt: function(prompt) { _prompt.innerHTML = prompt + options.separator; },
			getPrompt: function() { return _prompt.innerHTML.replace(new RegExp(options.separator + '$'), ''); },
			setTheme: function(theme) { _terminal.classList.remove('terminal-' + options.theme); options.theme = theme; _terminal.classList.add('terminal-' + options.theme); },
			getTheme: function() { return options.theme; },
			endExecute: endExecute,
			output: output,
			execute: execute
		}
	};

	// node.js
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = Terminal;

	// web browsers
	} else {
		var oldTerminal = global.Terminal;
		Terminal.noConflict = function () {
			global.Terminal = oldTerminal;
			return Terminal;
		};
		global.Terminal = Terminal;
	}

})(this);
